// 16 个新闻类型的唯一来源。
// 后台菜单、新闻列表、类型下拉框、首页类型板块都从这里取值，避免多处硬编码。
export interface NewsType {
  id: number
  name: string
}

export const NEWS_TYPES: NewsType[] = [
  { id: 1, name: 'Cherish the Earth and support the development of space' },
  { id: 2, name: 'A fair and just caring society' },
  { id: 3, name: 'Respect religious and partisan beliefs' },
  { id: 4, name: 'The best urban structure' },
  { id: 5, name: 'Everyone shares the results of success' },
  { id: 6, name: 'The safest and most peaceful place' },
  { id: 7, name: "There are opportunities for work and realizing one's ideals" },
  { id: 8, name: 'Every couple and their descendants make a contribution' },
  { id: 9, name: 'Filial piety towards parents and respect for elders' },
  { id: 10, name: 'Taking outstanding caring individuals as role models' },
  { id: 11, name: 'Healthy body, enjoy life' },
  { id: 12, name: 'Good and healthy hobbies' },
  { id: 13, name: 'Everyone can make their dreams come true' },
  { id: 14, name: 'Share experiences with confidence' },
  { id: 15, name: 'Understand the position of humanity' },
  { id: 16, name: 'Everyone is very happy' },
]

const NAME_MAP: Record<number, string> = NEWS_TYPES.reduce((acc, t) => {
  acc[t.id] = t.name
  return acc
}, {} as Record<number, string>)

export function getNewsTypeName(id: number | string): string {
  return NAME_MAP[Number(id)] || ''
}
